import React, { useEffect, useState } from 'react'
import YouTube from 'react-youtube'
import { MdClose } from 'react-icons/md'
import { IoCheckmarkCircleOutline } from 'react-icons/io5'
import MdmIcon from './MdmIcon'
import { PLATFORMS } from './MdmData'
import { formatDuration } from './mdmUtils'

const MdmCardModal = ({ card, section, onClose }) => {

    const [duration, setDuration] = useState(null)

    useEffect(() => {
        setDuration(null)
    }, [card?.videoId])

    useEffect(() => {
        const onKeyDown = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKeyDown)
        document.body.style.overflow = 'hidden'
        return () => {
            document.removeEventListener('keydown', onKeyDown)
            document.body.style.overflow = ''
        }
    }, [onClose])

    if (!card) return null

    return (
        <div className="mdm-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
            <div className="mdm-modal" role="dialog" aria-modal="true">
                <div className="mdm-modal-header">
                    <div className="mdm-modal-icon">
                        <MdmIcon name={card.icon} />
                    </div>
                    <div style={{ minWidth: 0 }}>
                        <h5>{card.t}</h5>
                        <div className="mdm-modal-meta">
                            {card.platform && <span className={`mdm-pill mdm-plat-${card.platform}`}>{PLATFORMS[card.platform].full}</span>}
                            {duration && <span className="mdm-mins">{duration}</span>}
                            <span className="mdm-mins">{(card.platform || duration) ? '· ' : ''}{section?.title}</span>
                        </div>
                    </div>
                    <button className="mdm-modal-close" onClick={onClose} aria-label="Close">
                        <MdClose size={18} />
                    </button>
                </div>
                <div className="mdm-modal-body">
                    {card.videoId ? (
                        <div className="mdm-player">
                            <YouTube
                                videoId={card.videoId}
                                opts={{ width: '100%', height: '100%', playerVars: { autoplay: 1, rel: 0 } }}
                                className="mdm-yt-wrap"
                                iframeClassName="mdm-yt-iframe"
                                title={card.t}
                                onReady={(e) => setDuration(formatDuration(e.target.getDuration()))}
                            />
                        </div>
                    ) : (
                        <div className="mdm-player mdm-norec">
                            <div className="mdm-norec-in">
                                Not recorded yet<br />
                                <span style={{ fontSize: '12px' }}>This module is planned — check back soon.</span>
                            </div>
                        </div>
                    )}

                    {card.learn?.length > 0 &&
                        <>
                            <div className="mdm-lbl">What you will learn</div>
                            <ul className="mdm-learn">
                                {card.learn.map((item, i) => (
                                    <li key={i}>
                                        <span className="mdm-check"><IoCheckmarkCircleOutline size={17} /></span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default MdmCardModal
